import type { CSSProperties } from 'react';

import SimpleModal from '@/ui/SimpleModal';

import { ButtonElement } from '../shared/buttonElement/ButtonElement';
import { Input } from '../shared/inputElement/Input';
import { SectionElement } from '../shared/sectionElement/SectionElement';
import type { ResetPasswordModalElementProps } from './ResetPasswordModalElement.types';

export function ResetPasswordModalElement({
  isOpen,
  onOpenChange,
  onCancel,
  translations,
  isLoading,
  hasSetPassword,
}: ResetPasswordModalElementProps) {
  const generatedStyle = {
    '--overlay-background-color': '#00000030',
    '--modal-close-button-color': undefined,
    '--modal-close-button-placement-top': '24px',
    '--modal-close-button-placement-right': '24px',
  } as CSSProperties;

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={onOpenChange}
      className="shadow-lg sm:rounded-md overflow-hidden"
      style={generatedStyle}
      shouldCloseOnOutsideClick={false}
      showCloseButton={false}
      showRoundedBorders={false}
    >
      <SectionElement
        title={hasSetPassword ? translations?.['manage.password.title'] : translations?.['manage.password.set_title']}
        subTitle={
          !hasSetPassword && <p className="text-sm text-gray-400">{translations?.['manage.password.set_subtitle']}</p>
        }
        className="bg-white w-full sm:w-[460px]"
      >
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <Input
              id="reset-password-password"
              type="password"
              name="password"
              label={translations?.['manage.password.form.password_label']}
              placeholder={translations?.['manage.password.form.password_placeholder']}
              required
              helperText={translations?.['manage.password.form.requirements_text']}
            />

            <Input
              id="reset-password-password-confirmation"
              type="password"
              name="password_confirmation"
              label={translations?.['manage.password.form.confirm_password_label']}
              placeholder={translations?.['manage.password.form.confirm_password_placeholder']}
              required
            />
          </div>

          <div className="flex justify-end gap-2">
            <ButtonElement variant="default" disabled={isLoading} type="button" onClick={onCancel}>
              {translations?.['shared.cta.cancel']}
            </ButtonElement>
            <ButtonElement variant="primary" disabled={isLoading} type="submit">
              {translations?.['shared.cta.submit']}
            </ButtonElement>
          </div>
        </div>
      </SectionElement>
    </SimpleModal>
  );
}
